module.exports = __webpack_public_path__ + "img/2fa.d644cb00.png";